import { useMobileOS } from '@beef/react';

/** Определяет является ли устройство мобильным */
export const useIsMobile = () => !!useMobileOS();

/** Определяет мобильную OS */
export { useMobileOS as useMobileOs };
